module.exports = __webpack_public_path__ + "static/img/bg1.c93fcb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.png
// module id = /sIz
// module chunks = 1